__webpack_require__.p = "/area/web/content/";